var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"accept-button",attrs:{"title":"Mark as Accepted"}},[_c('i',{staticClass:"fa fa-check accept-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }